import React from 'react'
import { CAPABILITY } from '@trustero/trustero-api-web/lib/authz/permissions_pb'
import { FilterName, FilterParam } from '../FilterBar.types'
import { useFilterBarValues } from '../FilterBar.context'
import { FilterDropdown } from './FilterDropdown'

const REPORT_PLAYBOOK_CAPABILITIES = [CAPABILITY.CAN_VIEW_REPORTS]

export const ReportPlaybookFilterDropdown = React.memo(
  ({ isNested = false }: { isNested?: boolean }): JSX.Element => {
    const filterBarValues = useFilterBarValues()
    const filterValues = filterBarValues.transformFilter(
      FilterParam.REPORT_PLAYBOOK,
      'reportPlaybook',
    )
    if (!filterValues.length) return <></>

    return (
      <FilterDropdown
        filterParam={FilterParam.REPORT_PLAYBOOK}
        filterName={FilterName.REPORT_PLAYBOOK}
        filterValues={filterValues}
        isNested={isNested}
        requiredCapabilities={REPORT_PLAYBOOK_CAPABILITIES}
      />
    )
  },
)
